import { render, staticRenderFns } from "./SurveyCake.vue?vue&type=template&id=58db97fa&scoped=true"
import script from "./SurveyCake.vue?vue&type=script&lang=js"
export * from "./SurveyCake.vue?vue&type=script&lang=js"
import style0 from "./SurveyCake.vue?vue&type=style&index=0&id=58db97fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db97fa",
  null
  
)

export default component.exports